export const ViewerType = 'wixui.TextOnPath' as const;

export const TestIds = {
  AddPanel: 'text-on-path-add-panel',
  root: 'text-on-path',
};

export const ViewerTestIds = {
  root: 'textOnPathRoot',
  text: 'textOnPathText',
  path: 'textOnPathPath',
  a11yRoot: 'textOnPathA11yRoot',
};

export const DataType = 'TextOnPathData';
export const HelpIds = {
  design: 'TODO',
  layoutPanel: 'layout-panel',
};
